import {Controller} from "stimulus"
import EventEmitter from "./../utils/EventEmitter"

/**
 * Base class for modals
 */
export default class extends Controller {

    static targets = [
    ]

    initialize(){
        this.initEvents()
    }

    initEvents() {
        EventEmitter.on(`modal-before-opened-${this.name}`, e => this.beforeOpened(e))
        EventEmitter.on(`modal-after-closed-${this.name}`, e => this.afterClosed(e))
    }

    beforeOpened(e) {
        console.log("before opened !", this.name)
    }

    afterClosed(e) {
        console.log("after closed !", this.name)
    }

    get name(){
        return this.data.get("name")
    }

}